export const reportingPlatforms = [
  {
    name: 'Facebook',
    steps: [
      'Open the post you want to report.',
      'Click or tap the three-dot menu on the post.',
      'Select “Report post” or “Find support or report.”',
      'Choose the reason that best describes the violation.',
      'Follow the instructions and submit the report.'
    ],
    notes: [
      'Facebook/Meta provides reporting options for issues such as bullying or harassment, hate speech, violence, scams, false information, nudity, child safety, impersonation, and intellectual-property violations.',
      'For serious content, report the specific post rather than only reporting the person’s profile. Meta says reports are handled confidentially.',
      'Best practice: Save the post URL and take a screenshot before reporting.'
    ],
    source: {
      label: 'Meta Safety Center',
      url: 'https://www.meta.com/safety/topics/online-child-protection/reporting'
    }
  },
  {
    name: 'Instagram',
    steps: [
      'Open the post.',
      'Tap the three-dot menu in the top-right corner.',
      'Tap “Report.”',
      'Select a reason.',
      'Choose the most relevant category or subcategory.',
      'Submit the report.'
    ],
    notes: [
      'Instagram also allows you to report Reels, Stories, comments, profiles, messages, and other content. Include relevant usernames, links, and descriptions when applicable.',
      'If the issue is bullying or harassment, report the specific content first, then consider blocking or restricting the account.'
    ],
    source: {
      label: 'Instagram Community Guidelines',
      url: 'https://storage.googleapis.com/transparency_hub_documents/675211559efd527760c64415/community_guidelines/1778284837.pdf'
    }
  },
  {
    name: 'X (formerly Twitter)',
    steps: [
      'Open the post.',
      'Click or tap the three-dot menu.',
      'Select “Report post.”',
      'Choose the reason.',
      'Answer any additional questions.',
      'Submit the report.'
    ],
    notes: [
      'You can also report an entire profile if the problem is broader than one particular post.',
      'X says it acknowledges properly submitted reports within 24 hours; resolving a report may take longer.'
    ],
    source: {
      label: 'X Help Center',
      url: 'https://help.x.com/en/safety-and-security/report-a-post'
    }
  },
  {
    name: 'TikTok',
    steps: [
      'Open the video or post.',
      'Tap “Share” or press and hold the post.',
      'Tap “Report.”',
      'Choose a reason and select a subcategory if requested.',
      'Tap “Submit.”'
    ],
    notes: [
      'TikTok has separate reporting options for comments, direct messages, accounts, LIVE content, impersonation, bullying, and other issues.',
      'You can report content from the TikTok app or a web browser.'
    ],
    source: {
      label: 'TikTok Support',
      url: 'https://www.tiktok.com/support/faq_detail?id=7636676986282449428&category=web_account'
    }
  },
  {
    name: 'YouTube',
    steps: [
      'Open the video.',
      'Click “More” (the three-dot menu) below the video.',
      'Select “Report.”',
      'Choose the reason.',
      'Click “Report” to submit.'
    ],
    notes: [
      'For a YouTube Short, open the Short, select More → Report, choose a reason, and provide details if requested. Timestamps or descriptions can be useful.',
      'You can also report comments, channels, community posts, live chat messages, ads, privacy violations, and legal issues.',
      'YouTube says reporting is anonymous. A report does not automatically remove content; it is reviewed against YouTube’s policies.'
    ],
    source: {
      label: 'YouTube Help',
      url: 'https://support.google.com/youtube/answer/2802027'
    }
  }
];